<template>
  <div class="fr-view" ref="viewer" v-html="content || emptyText"></div>
</template>

<script>
export default {
  name: 'html-view',
  props: {
    emptyText: {
      type: String,
      default: '请输入文字'
    },
    content: {
      type: String,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep  ul {
  list-style: disc;
}
</style>
